// Shared mapping for the 42 supported "ship to" countries.
// Codes are from src/util/Countries.js

const countryNames = {
  US: "United States",
  CA: "Canada",
  GB: "United Kingdom",
  AU: "Australia",
  DE: "Germany",
  FR: "France",
  IT: "Italy",
  ES: "Spain",
  NL: "Netherlands",
  PL: "Poland",
  SE: "Sweden",
  NO: "Norway",
  FI: "Finland",
  DK: "Denmark",
  IE: "Ireland",
  PT: "Portugal",
  BE: "Belgium",
  CH: "Switzerland",
  AT: "Austria",
  CZ: "Czech Republic",
  SK: "Slovakia",
  HU: "Hungary",
  RO: "Romania",
  BG: "Bulgaria",
  GR: "Greece",
  SI: "Slovenia",
  HR: "Croatia",
  EE: "Estonia",
  LV: "Latvia",
  LT: "Lithuania",
  LU: "Luxembourg",
  MT: "Malta",
  CY: "Cyprus",
  NZ: "New Zealand",
  AE: "United Arab Emirates",
  IL: "Israel",
  TR: "Turkey",
  MX: "Mexico",
  BR: "Brazil",
  AR: "Argentina",
  ZA: "South Africa",
  BD: "Bangladesh",
};

export const getCountryName = (code) => countryNames[code] || code;

export default countryNames;
